import { Component, Input, OnInit } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_APP_CULTURE_CODE } from '../../../languages/language.model';

@Component({
    selector: 'topo-culture-code-column',
    templateUrl: './culture-code-column.component.html',
    styleUrls: ['./culture-code-column.component.scss'],
    standalone: false
})
export class CultureCodeColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor(private translationService: TranslateService) {}

  ngOnInit(): void {}

  get fieldValue(): string {
    const value = this.document?.[this.field.systemName] ?? DEFAULT_APP_CULTURE_CODE;
    return this.translationService.instant(`LANGUAGES.LANGUAGE-${value}`);
  }
}
